export default [
  {
    name: 'Top',
    id: 'top',
  },
  {
    name: 'Bottom',
    id: 'bottom',
  },
];



// WEBPACK FOOTER //
// ./src/positions.js